module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/legal/legal.component.css
// module id = ./src/app/legal/legal.component.css
// module chunks = main